<input
  #uploadInput
  hidden
  class="file-control"
  type="file"
  [accept]="getInputAccept()"
  (change)="onFileSelect($event)"
/>

@if (fileName) {
  <span class="filename" [wuiTooltip]="fileName" (click)="onUpload()">
    {{ fileName }}
  </span>
}

@if (fileName) {
  <button class="clear" wui-button color="accent" (click)="clear()">
    <wf-icon iconName="x-close" iconClass="small"></wf-icon>
  </button>
}

@if (!fileName) {
  <div class="upload-03">
    <button
      wui-stroked-button
      color="primary"
      [wuiTooltip]="getInputAccept()"
      (click)="onUpload($event)"
    >
      <wf-icon iconName="upload-03" [text]="'PickFile' | translate"></wf-icon>
    </button>
    <span class="hint">
      {{ 'PickFileWithFormat' | translate }} {{ getInputAccept() }}
    </span>
  </div>
}

@if (fileError) {
  <div class="error red">
    {{ fileError.message }}
  </div>
}
